var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosActivation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.021,
    height: 43.988,
    viewBox: "0 0 25.021 43.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POS-activation",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1494",
    "data-name": "Trazado 1494",
    d: "M403.36,125.492V119.48H386.742v6.012a4.264,4.264,0,0,0-4.2,4.264v24.088a4.264,4.264,0,0,0,3.666,4.217v1.016a4.4,4.4,0,0,0,4.391,4.391h8.9a4.395,4.395,0,0,0,4.4-4.391v-1.02a4.264,4.264,0,0,0,3.666-4.217V129.753a4.264,4.264,0,0,0-4.2-4.26Zm-14.4-3.8h12.183v11.138H388.959ZM399.5,160.972h-8.9a1.9,1.9,0,0,1-1.891-1.894v-.973H401.4v.973a1.9,1.9,0,0,1-1.893,1.893Zm5.814-7.131a2.02,2.02,0,0,1-2.02,2.02H386.8a2.02,2.02,0,0,1-2.02-2.02V129.753a2.02,2.02,0,0,1,1.958-2.015v7.313H403.36v-7.313a2.02,2.02,0,0,1,1.956,2.015Z",
    transform: "translate(-382.54 -119.48)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1495",
    "data-name": "Trazado 1495",
    d: "M440.29,354.795h16.383v-8H440.29Zm2.244-5.76h11.895v3.516H442.534Z",
    transform: "translate(-435.97 -329.785)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_767",
    "data-name": "Rect\\xE1ngulo 767",
    width: 3.142,
    height: 2.243,
    transform: "translate(4.394 26.956)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_768",
    "data-name": "Rect\\xE1ngulo 768",
    width: 3.142,
    height: 2.243,
    transform: "translate(10.94 26.956)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_769",
    "data-name": "Rect\\xE1ngulo 769",
    width: 3.142,
    height: 2.243,
    transform: "translate(17.486 26.956)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_770",
    "data-name": "Rect\\xE1ngulo 770",
    width: 3.142,
    height: 2.243,
    transform: "translate(4.394 31.145)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_771",
    "data-name": "Rect\\xE1ngulo 771",
    width: 3.142,
    height: 2.243,
    transform: "translate(10.94 31.145)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_772",
    "data-name": "Rect\\xE1ngulo 772",
    width: 3.142,
    height: 2.243,
    transform: "translate(17.486 31.145)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1496",
    "data-name": "Trazado 1496",
    d: "M109.6,57.866l-2.131-1.709L105.99,58l3.987,3.2,5.237-6.654-1.852-1.457Z",
    transform: "translate(-98.061 -49.109)",
    fill: "#ec0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosActivation);
export default __webpack_public_path__ + "static/media/POS-activation.5dc793564d1daaa433b23ce634809ba7.svg";
export { ForwardRef as ReactComponent };